import { Component, OnInit } from '@angular/core';
import { DalService } from 'src/app/services/dal.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { interval } from 'rxjs';
import { Router } from '@angular/router';
// import { Meta } from '@angular/platform-browser'; 
// import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})

export class HomepageComponent implements OnInit {

  lstVolumeLeader = [];
  lstTicker = [];
  lstTopGainer = [];
  lstTopLoser = [];
  lstIndexes = [];
  subscription: any;
  currenttime: number = Date.now();

  constructor(
    private dal: DalService,
    private ls: LocalStorageService,
    private router: Router,
    // private meta: Meta
  ) { 
    this.getMarketData();
    
  }

  getMarketData() {
    this.getLocalMarketData();
    this.dal.getTickerData().then((res: any) => {
      this.getLocalMarketData();
    })  
    this.dal.getVolumeLeaderData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getTopGainerData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getTopLoserData().then((res: any) => {
      this.getLocalMarketData();
    })
    this.dal.getIndexData().then((res: any) => {
      this.getLocalMarketData();
    })
    
    this.currenttime = Date.now();
  }

  getLocalMarketData(){
    this.ls.getObject("VolLeaders").then((res: any) => {
      this.lstVolumeLeader = res || [];
    });
    this.ls.getObject("TopGainers").then((res: any) => {
      this.lstTopGainer = res || [];
    });
    this.ls.getObject("TopLosers").then((res: any) => {
      this.lstTopLoser = res || [];
    });
    this.ls.getObject("Indexes").then((res: any) => {
      this.lstIndexes = res || [];
    });
    this.ls.getObject("Tickers").then((res: any) => {
      this.lstTicker = res || [];
    });
  }

  ngOnInit() {
    // this.meta.addTag({ name: 'title', content: 'Best Brokerage Firm in Pakistan- MSL Trade' });  
    this.subscription = interval(60000).subscribe(x => {
      this.getMarketData();
    });
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  openClientLogin() {
    var iframe = '<html><head><style>body, html {width: 100%; height: 100%; margin: 0; padding: 0}</style></head><body><iframe src="http://mline.mailxs.pk/" style="height:calc(100% - 4px);width:calc(100% - 4px)"></iframe></html></body>';
    var win = window.open("","_blank");
    win.document.write(iframe);
  }

  openTechnicalGraph() {
    var iframe = '<html><head><style>body, html {width: 100%; height: 100%; margin: 0; padding: 0}</style></head><body><iframe src="http://visiontech.pk/livefeed/tv2/" style="height:calc(100% - 4px);width:calc(100% - 4px)"></iframe></html></body>';
    //var win = window.open("","","width=600,height=480,toolbar=no,menubar=no,resizable=yes");
    var win = window.open("","_blank");
    win.document.write(iframe);
  }

  goToOnDigiAccOpen() {
    window.open("https://www.aof.com.pk/?NDQ3ODU3NjIyODg0NTI3ODk4MjI1NzIyMTI5NzM3NDc3Mjg0MzQ3OA==", "_blank");
  }

  openAccountOpeningProcess(){
    this.router.navigateByUrl('/accountopeningprocess');
  }

  goCDCGatewayAccOpen() {
    window.open("https://cgp.cdcaccess.com.pk/cdc/cgp/r/centralized-gateway-portal/login?intermediary=5IJTN49VJ3HHO", "_blank");
  }
}
